import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { verticalSigningQueryKeys } from "../queries/verticalSigning/queryKeys"

import { useVerticalSigningMutation } from "./useVerticalSigningMutation"

export function useVerticalSignDelete(
    signId,
    poleId,
    config = {},
) {
    const url = `vertical_signs/${signId}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    return useVerticalSigningMutation(
        url,
        axiosInstance.delete,
        {},
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.verticalSign(signId) })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.pole(poleId) })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.project() })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.layer() })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.stats_categories() })
                queryClient.invalidateQueries({ queryKey: verticalSigningQueryKeys.stats_conditions() })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)

                config.onSuccess?.(data)
            },
        },
    )
}